import React,{useState} from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";

export default function LeaveRequestModal({showLeave,setShowLeave}){

const [fromDate,setFromDate]=useState(null);
const [toDate,setToDate]=useState(null);

return(

<div>
     <Modal
show={showLeave}
onHide={()=>setShowLeave(false)}
centered
>

<Modal.Header closeButton>
<Modal.Title>Add Leave Request</Modal.Title>
</Modal.Header>

<Modal.Body>

{/* Employee Name */}

<Form.Group className="mb-3">

<Form.Label>Employee Name</Form.Label>

<Form.Select>
<option>Select</option>
<option>John</option>
<option>David</option>
<option>Andrew</option>
</Form.Select>

</Form.Group>


{/* Leave Type */}

<Form.Group className="mb-3">

<Form.Label>Leave Type</Form.Label>

<Form.Select>
<option>Select</option>
<option>Casual Leave</option>
<option>Sick Leave</option>
<option>Earned Leave</option>
</Form.Select>

</Form.Group>


{/* Date Section */}

<Row className="mb-3">

<Col md={6} xs={12}>

<Form.Label>From</Form.Label>

<div className="position-relative">

<DatePicker
selected={fromDate}
onChange={(date)=>setFromDate(date)}
className="form-control"
placeholderText="dd/mm/yyyy"
/>

<FiCalendar className="calendar-icon"/>

</div>

</Col>


<Col md={6} xs={12}>

<Form.Label>To</Form.Label>

<div className="position-relative">

<DatePicker
selected={toDate}
onChange={(date)=>setToDate(date)}
className="form-control"
placeholderText="dd/mm/yyyy"
/>

<FiCalendar className="calendar-icon"/>

</div>

</Col>

</Row>


{/* Days Section */}

<Row className="mb-3">

<Col md={6} xs={12}>

<Form.Label>No of Days</Form.Label>

<Form.Control type="text"/>

</Col>

<Col md={6} xs={12}>

<Form.Label>Remaining Days</Form.Label>

<Form.Control type="text"/>

</Col>

</Row>


{/* Reason */}

<Form.Group>

<Form.Label>Reason</Form.Label>

<Form.Control
as="textarea"
rows={4}
/>

</Form.Group>

</Modal.Body>


<Modal.Footer>

<Button variant="light">
Cancel
</Button>

<Button style={{ background: "#ff6b1a",}}  className="add-leave border border-1" >
Add Leaves
</Button>

</Modal.Footer>

</Modal>
<style>
     {
          `.calendar-icon{
position:absolute;
right:10px;
top:50%;
transform:translateY(-50%);
color:#999;
pointer-events:none;
}
.add-leave{
 background: "#ff6b1a",
}
          `
     }
</style>
</div>


)

}